module.exports = __webpack_public_path__ + "static/fonts/Alibaba-PuHuiTi-Medium.c3d907d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Alibaba-PuHuiTi-Medium.ttf
// module id = op08
// module chunks = 40